export interface EmailErrorResponse {
    statusCode: number;
    title: string;
    message: string;
    errorCode: string;
    emailAddress: string;
}

export enum EmailErrorCode {
    EMAIL_ADDRESS_UNUSABLE = 'EMAIL_ADDRESS_UNUSABLE',
    EMAIL_TEMPORARILY_UNAVAILABLE = 'EMAIL_TEMPORARILY_UNAVAILABLE'
}

export interface EmailValidationError extends Error {
    errorCode: EmailErrorCode;
    emailAddress: string;
    title: string;
} 